var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action } from "mobx";
var BaseStore = /** @class */ (function () {
    function BaseStore() {
    }
    BaseStore.prototype.setParam = function (key, value) {
        var _a;
        Object.assign(this, (_a = {}, _a[key] = value, _a));
    };
    __decorate([
        action.bound
    ], BaseStore.prototype, "setParam", null);
    return BaseStore;
}());
export default BaseStore;
